import { Component, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DashboardDialogFramePart, DialogAction, DialogContext } from '@eforall/dashboard';
import { AIPromptDetails } from '@interfaces';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { MarkdownModule, provideMarkdown } from 'ngx-markdown';
import { FuncService } from '../../../../services';
import { AdvisorPromptResponseOrErrorPart } from './response-or-error/response-or-error.part';

@Component({
	selector: 'advisor-prompt-dialog',
	standalone: true,
	imports: [
		DashboardDialogFramePart,
		TabStripModule,
		MarkdownModule,
		AdvisorPromptResponseOrErrorPart
	],
	providers: [provideMarkdown()],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './advisor-prompt.dialog.html'
})

export class AdvisorPromptDialog implements OnInit {

	public dialogRef = inject(MatDialogRef<AdvisorPromptDialog>);
	public dialogContext: DialogContext<{ aiPromptId: number }> = inject(MAT_DIALOG_DATA);

	private func = inject(FuncService);
	public dialogData = signal<AIPromptDetails | undefined>(undefined);


	async ngOnInit() {
		const data = this.dialogContext.data;
		if (data) {
			this.dialogData.set(await this.func.advisor.getPromptDetailsById({ aiPromptId: data.aiPromptId }));
		}
	}

	public actions: DialogAction[] = [
		{
			id: 'close',
			cssClass: signal(undefined),
			enabled: signal(true),
			visible: signal(true),
			text: signal('Close'),
			linkType: "no-action",
			willCloseDialog: true,
		}
	];

}